var _polygon, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 7 5",
    style: {
      enableBackground: "new 0 0 7 5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7,0 3.5,5 0,0 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,2.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepStart);
export default __webpack_public_path__ + "static/media/stepStart.9573af027aa1e5a7a39f581748a1bbf5.svg";
export { ForwardRef as ReactComponent };